module.exports = __webpack_public_path__ + "static/media/38-1.d47101f5.png";